import { EventTypesStore, NewEventTypeStore, DropDownEventTypesStore } from './event-types-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new EventTypesStore());
  storeBuilder.addRepository(new DropDownEventTypesStore());
  storeBuilder.addRepository(new NewEventTypeStore());
}
